import React from 'react';
import { User } from '../../usersTypes';
import TableCell from '../../../components/table/TableCell';

type Props = {
  user: User;
};

const UserLoginTableCell = ({ user }: Props) => {
  return <TableCell>{user.login}</TableCell>;
};

export default UserLoginTableCell;
